export default "__VITE_ASSET__Bj4wyQwf__"